module.exports = __webpack_public_path__ + "img/GC111.39ddb03d.jpg";